"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var BaseTransform_1 = require("./BaseTransform");
var changeCase_1 = require("../../utils/changeCase");
var GroupTransform = /** @class */ (function (_super) {
    __extends(GroupTransform, _super);
    function GroupTransform() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GroupTransform.prototype.execute = function (queryResponse, queryOptions, executionOptions) {
        var response = {};
        var groupTransformOptions = this.options.groupTransformOptions;
        if (queryResponse) {
            var groupByKey_1 = groupTransformOptions.groupByKey;
            var groupByKeyValues = __spreadArrays(Array.from(new Set(queryResponse.map(function (element) { return element[groupByKey_1]; }))));
            var _loop_1 = function (groupByKeyValue) {
                response[changeCase_1.camelCase(groupByKeyValue.toString())] = queryResponse.filter(function (element) { return element[groupByKey_1] === groupByKeyValue; });
            };
            for (var _i = 0, groupByKeyValues_1 = groupByKeyValues; _i < groupByKeyValues_1.length; _i++) {
                var groupByKeyValue = groupByKeyValues_1[_i];
                _loop_1(groupByKeyValue);
            }
        }
        return response;
    };
    return GroupTransform;
}(BaseTransform_1.BaseTransform));
exports.GroupTransform = GroupTransform;
//# sourceMappingURL=GroupTransform.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@kurtosys/ksys-app-template/dist/query/transform/GroupTransform.js
// module id = 320
// module chunks = 1